module.exports = __webpack_public_path__ + "static/media/2DGACM2.5a3eabd6.jpg";